export const baseurl = "https://api.hasinienterprises.co.in/v1/hasiniapi/admin/"
export const baseurlweb = "https://api.hasinienterprises.co.in/v1/hasiniapi/web/"
export const imgUrl = "https://api.hasinienterprises.co.in/"
